import { IModel } from '@src/js/separate-logic/interface/IModel';

export default class TemplateRecommendationModel implements IModel {
    private isShowTemplateRecommendation: boolean;

    public initModel() {
        this.isShowTemplateRecommendation = true;
    }
}
